import { render, staticRenderFns } from "./RenewableEnergyFAQ.vue?vue&type=template&id=35dc62bc&"
import script from "./RenewableEnergyFAQ.vue?vue&type=script&lang=js&"
export * from "./RenewableEnergyFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports